<template>
  <div class="form-group">
          <button class="btn solid-main" :disabled="loading">
            Iniciar sesión
          </button>
          <img
            v-show="loading"
            class="img-loading"
            src="../assets/dog-spinner.gif"
          />
  </div>
</template>

<script>
export default {
props : ['loading'],

}
</script>

<style>

</style>